import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import PropTypes from 'prop-types';
import './ClearableDisplayPill.scss';

const ConditionalClearButton = ({
  onClearClick,
  index,
  isBrokenLink = false,
}) =>
  onClearClick ? (
    <button
      type="button"
      onClick={onClearClick}
      data-testid={`clearable-display-pill-x-${index}`}
    >
      <Icon
        name="close"
        className={`fill ${isBrokenLink ? 'icon-white' : 'icon-black'}`}
        width={12}
        data-testid="close-icon"
      />
    </button>
  ) : null;

const ClearableDisplayPill = ({ tag, onClearClick, index, iconName }) => {
  return (
    <div
      className={`clearable-display-pill display-${iconName}`}
      data-testid={`clearable-display-pill-${index}`}
    >
      {iconName && (
        <Icon
          name={iconName}
          className="fill clearable-link-icon"
          width={12}
          data-testid="clearable-link-icon"
        />
      )}
      <span>{tag}</span>
      <ConditionalClearButton
        onClearClick={onClearClick}
        index={index}
        isBrokenLink={iconName === 'link-remove'}
      />
    </div>
  );
};

ClearableDisplayPill.propTypes = {
  tag: PropTypes.string.isRequired,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClearClick: PropTypes.func,
  iconName: PropTypes.string,
};

ClearableDisplayPill.defaultProps = {
  onClearClick: undefined,
  iconName: '',
};

export default ClearableDisplayPill;
